import script from "./LoyaltyCategoryEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoyaltyCategoryEdit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__